import { useContext, useEffect, useState } from "react";
import service from "../../../../api/services";
import { useParams } from "react-router";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import { HeaderHeading } from "../../../../Context";
import molecules from "../../../../components/molecules";
import { useToasts } from "react-toast-notifications";

const { ViewStoreSubAdmin } = organisms;
const { ConfirmationModal } = molecules;

export interface StoreSubAdminListProps {
    id: string;
    store_id: string;
    user: {
        id: string;
        username: string;
        email: string;
        mobile: string;
    };
}

const Index = () => {
    const params = useParams();
    const { addToast } = useToasts();

    const { setHeader, setSidebar }: any = useContext(HeaderHeading);

    const [storeSubAdminList, setStoreSubAdminList] = useState<StoreSubAdminListProps[]>([]);
    const [storeSubAdminSearchData, setStoreSubAdminSearchData] = useState<StoreSubAdminListProps[]>([]);

    const [storeSubAdminId, setStoreSubAdminId] = useState<string>("");
    const [toggleDeleteModal, setToggleDeleteModal] = useState<boolean>(false);

    // INFO:- API calling for get the store SubAdmin list
    const getStoreSubAdminList = async () => {
        try {
            const response = await service.store.getStoreStaffSubAdmin(
                { SubAdmin: true },
                params?.id || ""
            );
            setStoreSubAdminList(response?.data?.data);
            setStoreSubAdminSearchData(response?.data?.data)
        } catch (error: any) {
            console.error(error);
            addToast(error?.response?.data?.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    // end

    // INFO:- handle delete SubAdmin
    const handleDeleteSubAdmin = async () => {
        let data = {
            store_id: params?.id || "",
            staff_id: storeSubAdminId,
        };
        try {
            const response = await service.store.deleteStoreStaffSubAdmin(data);
            if (response?.status === 200 || response?.status === 201) {
                getStoreSubAdminList();
                addToast(response?.data?.message, {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            console.error(error);
            addToast(error?.response?.data?.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    // end

    // INFO:- handle search 
    const handleSearch = (value: string) => {
        if (!value) {
            setStoreSubAdminSearchData(storeSubAdminList)
        }
        let filterData: StoreSubAdminListProps[] = storeSubAdminList?.filter((item) =>
            item?.user?.username?.toLowerCase()?.includes(value.toLowerCase())
        );
        setStoreSubAdminSearchData(filterData)
    }
    // end

    useEffect(() => {
        getStoreSubAdminList();
        setHeader("Store - Store SubAdmin");
    }, []);
    return (
        <Wrapper>
            <ViewStoreSubAdmin
                storeSubAdminList={storeSubAdminSearchData}
                handleSearch={(value: string) => handleSearch(value?.trim())}
                handleDeleteSubAdmin={(id: string) => {
                    setToggleDeleteModal(!toggleDeleteModal);
                    setStoreSubAdminId(id);
                }}
            />
            {toggleDeleteModal && (
                <ConfirmationModal
                    show={toggleDeleteModal}
                    handleConfirmItem={() => {
                        setToggleDeleteModal(!toggleDeleteModal);
                        setStoreSubAdminId("");
                        handleDeleteSubAdmin();
                    }}
                    onHide={() => {
                        setToggleDeleteModal(!toggleDeleteModal);
                        setStoreSubAdminId("");
                    }}
                    message={"delete this SubAdmin"}
                />
            )}
        </Wrapper>
    );
};

export default Index;
